import { LuCkeditorOptions } from '../../lu-ckeditor.models';

export const removePlugins = (options: LuCkeditorOptions): string[] => {
	let removePlugin = [];
	if (options.addImageUploadViaDj && options.disableImageProperties) {
		removePlugin = [...removePlugin, 'image'];
	}

	if (options?.pluginsForRemoval?.length) {
		removePlugin = [...removePlugin, ...options.pluginsForRemoval];
	}

	return removePlugin;
};
